import { computed, inject, Injectable, signal } from '@angular/core';
import { UserArea } from '../models/user-area';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class AreaContextService {
  private readonly user = inject(UserService);
  private readonly _selectedAreaId = signal<string | null>(null);
  readonly selectedAreaId = this._selectedAreaId.asReadonly();
  readonly selectedArea = computed(() => {
    const selectedAreaId = this._selectedAreaId();

    if (!selectedAreaId) {
      return null;
    }

    return this.user.areas().find((area) => area.id === selectedAreaId) ?? null;
  });

  initialize(areas: UserArea[]) {
    if (!areas.length) {
      this._selectedAreaId.set(null);
      localStorage.removeItem('selected_area');
      return;
    }

    const saved = localStorage.getItem('selected_area');
    const hasSavedArea = saved ? areas.some((area) => area.id === saved) : false;

    if (saved && hasSavedArea) {
      this._selectedAreaId.set(saved);
    } else {
      this._selectedAreaId.set(areas[0].id);
      localStorage.setItem('selected_area', areas[0].id);
    }
  }

  select(areaId: string) {
    this._selectedAreaId.set(areaId);
    localStorage.setItem('selected_area', areaId);
  }
}
